import { formatDateLocale } from "@/shared/utils/formatDate";
import dayjs from "dayjs";
import { HIDE_DECIMAL, useConfig } from "@/hooks/useConfig";
import { round } from "lodash";
import { ExtendedActionPlanDetail } from "../../../api/v2/getActionPlan";

export const getProgressMetrics = (actionPlan: ExtendedActionPlanDetail) => {
  const { config } = useConfig();
  const formatCurrency = config.currency.formatCurrency;
  const {
    startDate,
    updatedAt,
    endDate,
    revenueTarget,
    revenueForecastToDate,
    revenueActualToDate,
    spendPlannedTotal,
    spendActualToDate,
    spendPlannedToDate,
    durationPercentage,
    spendPercentage,
    revenuePercentage,
  } = actionPlan;

  // TODO Ensure that these are using the correct metrics for the calculations.
  const timePeriodMetric = {
    title: "Time Period",
    progress: Math.min(100, durationPercentage),
    progressText: `${round(durationPercentage, 2)}% Complete`,
    info: [
      {
        title: "Start Date",
        value: actionPlan.startDate
          ? `${formatDateLocale(dayjs(startDate), { dateFormat: "DD MMM YYYY" })}`
          : "N/A",
      },
      {
        title: "Last Updated",
        value: updatedAt
          ? formatDateLocale(dayjs(updatedAt), { dateFormat: "DD MMM YYYY" })
          : "N/A",
      },
      {
        title: "End Date",
        value: endDate
          ? `${formatDateLocale(dayjs(endDate), { dateFormat: "DD MMM YYYY" })}`
          : "N/A",
      },
    ],
  };

  const spendMetric = {
    title: "Spend",
    progress: Math.min(100, spendPercentage),
    progressText: `${round(spendPercentage, 2)}% to target (${formatCurrency(spendActualToDate, HIDE_DECIMAL)} of ${formatCurrency(spendPlannedTotal, HIDE_DECIMAL)})`,
    info: [
      {
        title: "Planned to date",
        value: formatCurrency(spendPlannedToDate, HIDE_DECIMAL),
      },
      {
        title: "Spent to date",
        value: formatCurrency(spendActualToDate, HIDE_DECIMAL),
      },
      {
        title: "Difference",
        value: formatCurrency(spendActualToDate - spendPlannedToDate, HIDE_DECIMAL),
      },
    ],
  };

  const revenueMetric = {
    title: "Revenue",
    progress: Math.min(100, revenuePercentage),
    progressText: `${round(revenuePercentage, 2)}% to target (${formatCurrency(revenueActualToDate, HIDE_DECIMAL)} of ${formatCurrency(revenueTarget, HIDE_DECIMAL)})`,
    info: [
      {
        title: "Forecast to date",
        value: formatCurrency(revenueForecastToDate, HIDE_DECIMAL),
      },
      {
        title: "Earned to date",
        value: formatCurrency(revenueActualToDate, HIDE_DECIMAL),
      },
      {
        title: "Difference",
        value: formatCurrency(revenueActualToDate - revenueForecastToDate, HIDE_DECIMAL),
      },
    ],
  };

  return [timePeriodMetric, spendMetric, revenueMetric];
};
